import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetReferralLeaderboardV1Response } from './get-referral-leaderboard-v1-response';
import { getReferralLeaderboardV1ResponseSchema } from './get-referral-leaderboard-v1-response';

export async function getReferralLeaderboardV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetReferralLeaderboardV1Response>> {
  return getRequest<IGetReferralLeaderboardV1Response>({
    path: '/sys/referral/v1/leaderboard',
    schema: getReferralLeaderboardV1ResponseSchema,
    options,
  });
}
